import $ from "jquery";
import "slick-carousel";


const testSlider = 'popup-test-slider';

$(`.${testSlider}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  adaptiveHeight: true,
  arrows: false,
});



$('.control_popup').on('click', function() {
  // temporarily close all popups
  $('.popup').removeClass('is-active');
  $('.popup-content').addClass('hidden');

  // target the clicked popup
  const popup = $(this).find('.popup');

  // prepare the any sliders
  const sliderID = popup.data('slider');
  
  $(`.${sliderID}`).addClass('opacity-0');
  
  if (sliderID) {
    setTimeout(() => {
      $(`.${sliderID}`).slick("setPosition");
    }, 10);
  }

  // show popup
  popup.parents('.popup-content').removeClass('hidden');
  popup.addClass('is-active');
  $(`.${sliderID}`).removeClass('opacity-0');

});

$('.close-popup').on('click', function(event) {
  event.stopPropagation();
  $(this).parents('.popup').removeClass('is-active')
  $(this).parents('.popup-content').addClass('hidden')
});

$('body').on('click', function() {
  $('.popup.is-active').removeClass('is-active');
  $('.popup.is-active').parents('.popup-content').addClass('hidden');
});

$('.control_popup').on('click', function(event) {
  event.stopPropagation();
});

